/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import {
  AuthFacade,
  SharedFacade,
  SimultaneousService,
  UserDetailsFacade,
} from '@piqet-angular/data';
import {
  SIMULTANEOUS_LOGIN_DETECTED_TITLE,
  SIMULTANEOUS_LOGIN_DETECTED_TEXT,
  CustomModalService,
} from '@piqet-angular/shared';
import { AuthenticationService } from 'libs/data/src/lib/services/auth/authentication.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { CookieService } from 'ngx-cookie-service';
import { JoyrideService } from 'ngx-joyride';
import { Observable, Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'piqet-angular-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
})
export class LayoutComponent implements OnInit, AfterContentChecked, OnDestroy {
  typeSelected = 'line-spin-clockwise-fade';
  toggleNav = false;
  guidedTour!: Subscription;
  intervalId: any;
  private beaconScript: HTMLScriptElement | null = null;
  private beaconScriptSubscription!: Subscription;
  spinnerMessage$: Observable<string>;
  constructor(
    public sharedFacade: SharedFacade,
    private sharedService: SharedService,
    private swalService: SwalService,
    private cookieService: CookieService,
    private authService: AuthenticationService,
    private authFacade: AuthFacade,
    private cdref: ChangeDetectorRef,
    private simultaneousService: SimultaneousService,
    private modal: CustomModalService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private joyrideService: JoyrideService
  ) {
    this.spinnerMessage$ = this.sharedService.spinnerMessage$;
  }

  /**
   * True when the active route opted into a chrome-less layout (data.hideShell).
   * Synchronous getter — read on every change detection, so no timing window
   * where the footer briefly renders before the route data is available.
   */
  get hideShell(): boolean {
    let r: ActivatedRouteSnapshot | null = this.activatedRoute.snapshot.root;
    while (r) {
      if (r.data?.['hideShell'] === true) return true;
      r = r.firstChild;
    }
    return false;
  }
  @HostListener('window:click', ['$event.target']) // Replace 'yourEvent' with the actual event you want to listen to
  getNgSelectEvent(e: any) {
    if (
      e?.classList?.contains('ng-value-container') ||
      e?.classList?.contains('ng-arrow-wrapper') ||
      e?.classList?.contains('ng-select-container') ||
      e?.classList?.contains('ng-input') ||
      e?.classList?.contains('ng-placeholder')
    ) {
      const divElement: any = document.getElementsByClassName('ng-select-opened');
      if (divElement) {
        const data = divElement[0]?.getElementsByTagName('input');
        if (data) {
          data[1]?.focus();
        }
      }
    }
  }

  ngOnInit() {
    const token = this.cookieService.get('token');
    this.simultaneousService.logoutWarningPopup(token);
    // !!token && this.initBeaconScript();
    // this.beaconScriptSubscription = this.sharedService.removeBeaconScript$.subscribe(() => {
    //   this.removeBeaconScript();
    // });
    // this.refreshPage();
    this.guidedTour = this.sharedService.startTourObs$.subscribe((data: any) => {
      if (data.length && !data[0] && data[1] !== 'Yes') {
        this.router.navigate(['/dashboard']);
      } else if (data.length && data[0] && data[1] == 'org-footprint') {
        this.router.navigate(['/organization-report/upload-sku']);
      }
    });
  }
  refreshPage() {
    this.intervalId = setInterval(() => {
      this.CheckUserSession();
    }, 30000);
  }

  CheckUserSession() {
    const userId = this.cookieService.get('userId');
    const sessionId = this.cookieService.get('sessionId');

    // Only check if we have both userId and sessionId
    if (!userId || !sessionId) {
      this.authFacade.logout();
    }

    const payload = { userId, sessionId };

    this.authService.CheckUserSession(payload).subscribe((res: any) => {
      // If session is invalid
      if (!res.data?.isSessionValid) {
        //   let timerInterval: any;
        //   // Show warning popup for 10 seconds
        //   Swal.fire({
        //     title: SIMULTANEOUS_LOGIN_DETECTED_TITLE,
        //     html: SIMULTANEOUS_LOGIN_DETECTED_TEXT,
        //     icon: 'warning',
        //     timer: 10000,
        //     timerProgressBar: true,
        //     allowOutsideClick: false,
        //     allowEscapeKey: false,
        //     showConfirmButton: false,
        //     showCancelButton: false,
        //     customClass: 'Popupbackground simultaneous-login',
        //     didOpen: () => {
        //       const timer = Swal.getPopup()?.querySelector('b');
        //       timerInterval = setInterval(() => {
        //         if (timer) {
        //           timer.textContent = `${Math.ceil(Swal.getTimerLeft()! / 1000)}`;
        //         }
        //       }, 1000);
        //     },
        //     willClose: () => {
        //       clearInterval(timerInterval);
        //     }
        //   });

        // Logout after 10 seconds
        // setTimeout(() => {
        //   Swal.close();
        this.authFacade.logout();
        // }, 9500);
      }
      if (
        res.data?.hasOwnProperty('latestNews') &&
        !this.joyrideService.isTourInProgress() &&
        !Swal.isVisible()
      ) {
        this.modal.invoke('AdditionalInfoNews', {
          initialState: {
            item: res.data?.latestNews,
          },
          class: 'modal-xl',
        });
      }
    });
  }
  initBeaconScript() {
    // Add the Beacon script dynamically after the view has been initialized
    this.beaconScript = document.createElement('script');
    this.beaconScript.type = 'text/javascript';
    this.beaconScript.text = `
        !function (e, t, n) {
            function a() {
                var e = t.getElementsByTagName("script")[0],
                    n = t.createElement("script");
                n.type = "text/javascript", n.async = !0, n.src = "https://beacon-v2.helpscout.net", e.parentNode.insertBefore(n, e);
            }

            if (e.Beacon = n = function (t, n, a) {
                e.Beacon.readyQueue.push({ method: t, options: n, data: a });
            }, n.readyQueue = [], "complete" === t.readyState) return a();
            e.attachEvent ? e.attachEvent("onload", a) : e.addEventListener("load", a, !1);
        }(window, document, window.Beacon || function () { });
        window.Beacon('config', {
        color: '#9747FF' 
      });
        window.Beacon('init', '75d9824d-49ff-4f02-9789-2a04a2f2b0f9');
  `;
    document.head.appendChild(this.beaconScript);
  }

  private removeBeaconScript() {
    // Check if the Beacon script exists before trying to remove it
    if (this.beaconScript && this.beaconScript.parentNode) {
      this.beaconScript.parentNode.removeChild(this.beaconScript);
      this.beaconScript = null; // Reset the reference to null after removal
    }
  }

  ngOnDestroy() {
    this.beaconScriptSubscription?.unsubscribe();
    this.guidedTour?.unsubscribe();
    clearInterval(this.intervalId);
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const windowScrollPosition = window.scrollY + 0;
    if (windowScrollPosition > 0) {
      this.toggleNav = true;
    } else {
      this.toggleNav = false;
    }
  }
}
